/**
*  Date    : 2020/07/29
*  Author  : lbb1811
*  Declare : EventEmitter
*/
import Events from '@wtdc/eventemitter';

class EventEmitter extends Events {
  on(event, callback) {
    super.on(event, callback);
    return () => {
      this.off(event, callback);
    };
  }

  once(event, callback) {
    super.once(event, callback);
    return () => {
      this.off(event, callback);
    };
  }

  trigger(...params) {
    super.emit(...params);
  }

}

export default new EventEmitter();

export { EventEmitter };
